import type { RouteRecordRaw } from 'vue-router'
import { Layout } from '@/utils/routerHelper'

const adminVipRoutes: RouteRecordRaw[] = [
  {
    path: '/vip',
    name: 'Vip',
    component: Layout,
    meta: {
      title: '会员体系',
      icon: 'vi-ant-design:crown-outlined',
      alwaysShow: true
    },
    children: [
      {
        path: 'list',
        name: 'VipList',
        component: () => import('@/views/Admin/Vip/List.vue'),
        meta: {
          title: 'VIP配置',
          icon: 'mdi-crown'
        }
      },
      {
        path: 'benefit',
        name: 'VipBenefit',
        component: () => import('@/views/Admin/Vip/Benefit.vue'),
        meta: {
          title: 'VIP权益',
          icon: 'mdi-star-cog-outline'
        }
      },
      {
        path: 'gift-config',
        name: 'VipGiftConfig',
        component: () => import('@/views/Admin/Vip/GiftConfig.vue'),
        meta: {
          title: 'VIP加赠配置',
          icon: 'mdi-gift-outline'
        }
      },
      {
        path: 'record',
        name: 'VipRecord',
        component: () => import('@/views/Admin/Vip/Record.vue'),
        meta: {
          title: 'VIP记录',
          icon: 'mdi-clipboard-text-clock'
        }
      },
      {
        path: 'gift-env',
        name: 'VipGiftEnv',
        component: () => import('@/views/Admin/Vip/GiftEnv.vue'),
        meta: {
          title: 'VIP加赠环境',
          icon: 'mdi-earth'
        }
      }
    ]
  }
]

export default adminVipRoutes
